import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";

function Table(props) {
  const { data } = props
  const columns = [
      {
      dataField: "shop",
      text: "Shop",
      sort: true,
    },
    {
      dataField: "bets",
      text: "Bets",
      sort: true,
      formatter: (cell, row) => <>{Number(row.bets).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "total_stake",
      text: "Total Stake",
      sort: true,
      formatter: (cell, row) => <>{Number(row.total_stake.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "stake_tax",
      text: "Stake Tax",
      sort: true,
      formatter: (cell, row) => <>{Number(row.stake_tax.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "effective_stake",
      text: "Effective Stake",
      sort: true,
      formatter: (cell, row) => <>{Number(row.effective_stake.toFixed(2)).toLocaleString('en-GB')}</>,
    },

    {
      dataField: "boost",
      text: "Boost",
      sort: true,
      formatter: (cell, row) => <>{Number(row.boost.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => <>{Number(parseFloat(row?.wht ?? 0)?.toFixed(2)).toLocaleString('en-GB')}</>,
    },

    {
      dataField: "payout",
      text: "Payout",
      sort: true,
      formatter: (cell, row) => <>{Number(row.payout.toFixed(2)).toLocaleString('en-GB')}</>,
    },

    {
      dataField: "GGR",
      text: "GGR",
      sort: true,
      formatter: (cell, row) => <>{Number(row.GGR.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "GGR_ratio",
      text: "GGR Ratio",
      sort: true,
      formatter: (cell, row) => <>{Number(row.GGR_ratio.toFixed(2)).toLocaleString('en-GB')+'%'}</>,
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data.length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Shop Report"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Shop-Report-${moment(new Date()).format("DD/MM/YYYY")}`}

                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
